<template id="view-calendars">
  <!-- :class="{ 'container-fluid': isMobile, container: !isMobile }" -->
  <div class="container-fluid">
    <!-- 
      Formulario de edición
      TODO: Recuperar en background cada item que se vaya a editar
      -->

    <div
      id="dialogCalendars"
      style="text-align:left; z-index: 1003 !important;"
    >
      <calendars-form
        :showing="dlgShow"
        :formAction="formAction"
        :isMobile="isMobile"
        :formData="rowData"
        isModal="true"
        @formClosed="hideForm"
      >
      </calendars-form>
    </div>

    <div
      id="dialogCalendarDays"
      style="text-align:left; z-index: 2000 !important;"
    >
      <calendar-days-form
        :showing="dlgDaysShow"
        :isMobile="isMobile"
        :formData="rowData"
        :formAction="formAction"
        isModal="true"
        @formClosed="hideForm"
        z-index="1003"
      >
      </calendar-days-form>
    </div>

    <div class="row top-row">
      <div class="col-12">
        <h3>Calendarios</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 offset-xl-2">
        <ejs-grid
          ref="gridCalendar"
          class="r-space"
          :load="onGridLoad"
          :toolbarClick="toolbar_click"
          :actionBegin="onActionBegin"
          :actionComplete="onActionComplete"
          :toolbar="toolbar"
          :dataSource="gridData"
          :query="query"
          :allowSorting="true"
          :allowSelection="true"
          :allowExcelExport="true"
          :selectionSettings="selectionSettings"
          :allowFiltering="true"
          :allowPaging="true"
          :allowGrouping="false"
          :pageSettings="pageSettings"
          :editSettings="editSettings"
          :filterSettings="filterSettings"
          :queryCellInfo="setStyle"
          locale="es-CO"
        >
          <e-columns>
            <e-column
              field="id"
              headerText="Id"
              textAlign="Right"
              :width="90"
              :minWidth="90"
              clipMode="Clip"
              :isPrimaryKey="true"
            ></e-column>
            <e-column
              field="description"
              headerText="Calendario"
              filter="Menu"
              :width="200"
              clipMode="EllipsisWithTooltip"
              :required="true"
            ></e-column>
            <e-column
              field="isActive"
              headerText="isActive"
              :width="90"
              :required="true"
              :visible="false"
            >
            </e-column>
            <e-column
              field="active"
              headerText="Activa"
              :width="90"
              filter="CheckBox"
              :required="true"
              visible="true"
            >
            </e-column>
            <e-column
              headerText="Acciones"
              AllowFiltering="false"
              :width="100"
              :commands="customCommands"
            >
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</template>

<script>
export const CalendarsColumns = {
  COL_ID: 0,
  COL_NAME: 1,
  COL_IS_ACTIVE: 2,
  COL_ACTIVE: 3,
  COL_BUTTONS: 4
};

/*Imports de VueJS*/
import Vue from "vue";
import { FormActionEnum } from "../../services/enums.js";
/* import { mapGetters } from "vuex"; */
import CalendarsForm from "./CalendarsForm.vue";
import CalendarDaysForm from "./CalendarDaysForm.vue";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
import CultureMixin from "../../mixins/CultureMixin";

/*Imports de Syncfusion*/
import { Browser } from "@syncfusion/ej2-base";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DialogUtility } from "@syncfusion/ej2-popups";
import {
  DatePickerPlugin,
  DateRangePickerPlugin
} from "@syncfusion/ej2-vue-calendars";
import { TooltipPlugin, Tooltip } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Edit,
  Filter,
  Group,
  Page,
  Selection,
  CommandColumn,
  Toolbar,
  Sort,
  ExcelExport
} from "@syncfusion/ej2-vue-grids";

Vue.use(DateRangePickerPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(ButtonPlugin);
Vue.use(TooltipPlugin);

export default Vue.extend({
  name: "Calendars",
  props: {},
  components: { CalendarsForm, CalendarDaysForm },
  mixins: [PermissionMixin, ToastMixin, CultureMixin],
  created() {
    this.formAction = FormActionEnum.LIST;
  },
  async mounted() {
    this.setDefaultToolbar();
    if (this.isMobileDevice) {
      this.toolbar.push({
        text: "Fechas Personalizadas",
        tooltipText: "Administrar Días",
        prefixIcon: "e-cal",
        id: "daysTool"
      });
    }
    await this.reloadTool_click();
  },
  async beforeDestroy() {
    await this.$store.dispatch("calendars/clearCalendars");
  },
  updated() {
    //this.$refs.gridCalendar.ej2Instances.dataSource = this.calendarsList;
  },
  computed: {
    calendarsList() {
      //return this.$store.getters["calendars/allCalendars"];
      var list = this.$store.getters["calendars/allCalendars"];

      var salida = [];
      var hasItems = !!list;
      if (!hasItems) return salida;

      list.forEach(item => {
        let i = Object.assign({}, JSON.parse(JSON.stringify(item)));
        i.active = i.isActive ? "Activo" : "Inactivo";
        salida.push(i);
      });

      return salida;
    },
    rowData() {
      return this.$store.getters["calendars/currentCalendar"];
    },
    formData() {
      return JSON.parse(JSON.stringify(this.rowData));
    },
    customCommands() {
      //daysTool
      var canEdit = this.hasPermission("CanEdit");
      var cssEdit = canEdit ? "e-flat e-noback" : "e-flat e-noback not-allowed";

      var commands = this.commands;

      var customDays = {
        type: "Días Personalizados",
        buttonOption: {
          iconCss: "e-icons e-cal inline-command",
          click: this.daysTool_click,
          cssClass: cssEdit,
          disabled: !canEdit
        }
      };
      commands.push(customDays);
      return commands;
    }
  },
  data() {
    return {
      /* Parámetros del formulario*/

      dlgShow: false,
      dlgDaysShow: false,
      formAction: FormActionEnum.LIST,
      isMobile: Browser.isDevice,
      deleteDialog: {},
      /* Datos del Grid */
      gridData: {},
      toolTip: "",

      editparams: { params: { popupHeight: "300px" } },
      editSettings: {
        showDeleteConfirmDialog: true,
        allowEditing: true,
        allowEditOnDblClick: false,
        allowAdding: true,
        allowDeleting: false,

        mode: "Dialog"
      },
      //toolbar: undefined,
      pageSettings: { pageCount: 5, pageSize: 10 },
      allowSorting: true,
      filterSettings: {
        mode: "Immediate",
        immediatemodedelay: 0,
        type: Browser.isDevice ? "Menu" : "FilterBar",
        columns: [],
        ignoreAccent: true
      },
      filter: { type: "CheckBox" },
      selectionSettings: { persistSelection: true },
      query: ""
    };
  },
  provide: {
    grid: [
      Edit,
      Group,
      Sort,
      Filter,
      Page,
      Selection,
      CommandColumn,
      Toolbar,
      ExcelExport,
      Tooltip
    ]
  },
  methods: {
    /*Evento del Grid, al cargar ejecuta este código*/
    onGridLoad: function() {
      // this.setDefaultToolbar();

      if (this.isMobileDevice) {
        /*Ocultar la columnas en version móvil*/
        this.$refs.gridCalendar.ej2Instances.columns[
          CalendarsColumns.COL_BUTTONS
        ].visible = false;
        this.$refs.gridCalendar.ej2Instances.columns[
          CalendarsColumns.COL_IS_ACTIVE
        ].visible = false;
        this.$refs.gridCalendar.ej2Instances.columns[
          CalendarsColumns.COL_ACTIVE
        ].visible = false;
      }
    },

    /*Evento del Grid, Se ejecuta cada vez que ocurre una acción.*/
    async onActionBegin(args) {
      if (args.requestType === "filtering") {
        this.$refs.gridCalendar.showSpinner();
        if (args.columns && args.columns.length) {
          args.columns.forEach(col => {
            if (col.field == "name" || col.field == "active") {
              col.operator = "contains"; // set the “contains” operator for the ‘CustomerID’ column
            }
          });
        }
      }

      if (args.requestType === "refresh") {
        this.$refs.gridCalendar.showSpinner();
      }

      if (args.requestType === "beginEdit") {
        await this.editBtnClick(args);
        args.cancel = true;
      }

      if (args.requestType == "delete") {
        args.cancel = true;
      }
    },
    onActionComplete(args) {
      if (args.requestType === "filtering") {
        this.$refs.gridCalendar.hideSpinner();
      }

      if (args.requestType === "refresh") {
        this.$refs.gridCalendar.hideSpinner();
      }
    },

    /* Handlers propios del componente, los usamos para gestionar los eventos generados desde el Grid
     * No vamos a usar por ahora la funcionalidad de la edición básica del grid.
     */

    /* Handler de los botones de acción del Toolbar del Grid */
    async toolbar_click(args) {
      if (args.item.id === "deleteTool") {
        this.deleteTool_click();
        /*
        let rowData = this.getRowDataFromToolbar();
        let hasData = !!rowData;
        if (hasData) {
          console.log(
            "Pendiente funcionalidad de eliminación y/o inactivación"
          );
        }
        */
      }

      if (args.item.id === "addTool") {
        await this.addTool_click();
      }

      if (args.item.id === "viewTool") {
        await this.viewTool_click();
      }

      if (args.item.id === "editTool") {
        await this.editTool_click();
      }

      if (args.item.id === "exportTool") {
        this.exportTool_click(args);
      }

      if (args.item.id === "reloadTool"){
        await this.reloadTool_click();
      }

      if (args.item.id === "daysTool") {
        this.daysTool_click();
      }
    },
    /* Handler del botón de creación de Calendario */
    exportTool_click() {
      let hora = new Date().toISOString().slice(0, 10);
      let fName = "Calendarios" + hora + ".xlsx";
      let exportProps = {
        fileName: fName,
        includeHiddenColumn: false
      };

      this.$refs.gridCalendar.excelExport(exportProps);
      /* this.$refs.gridCalendar.excelExport(); */
    },
    async reloadTool_click(){
      try {
        this.$parent.showLoading();
        this.$store.dispatch("calendars/initCalendar");
        await this.$store.dispatch("calendars/getCalendars");
        this.gridData = this.calendarsList;
        this.$parent.hideLoading(500);
      } catch (error) {
        this.showToast("Error", "Error cargando los calendarios!", 2000);
        this.$parent.hideLoading(500);
      }
    },
    async addTool_click() {
      this.dlgShow = !this.dlgShow;
      this.$store.dispatch("calendars/initCalendar");

      this.formAction = FormActionEnum.ADD;
      await this.showForm();
    },
    async daysTool_click(args) {
      let rowData = null;
      if (args == undefined) {
        rowData = this.getRowDataFromToolbar();
      } else {
        rowData = this.getRowData(args);
      }

      let hasRowData = !!rowData;
      if (hasRowData) {
        this.formAction = FormActionEnum.EDIT;
        await this.showDaysForm(rowData);
      }
    },
    async viewTool_click(args) {
      let rowData = null;
      if (args == undefined) {
        rowData = this.getRowDataFromToolbar();
      } else {
        rowData = this.getRowData(args);
      }

      let hasRowData = !!rowData;
      if (hasRowData) {
        this.formAction = FormActionEnum.VIEW;
        await this.showForm(rowData);
      }
    },
    /* Handler del botón de edición de Calendario */
    async editTool_click(args) {
      let rowData = null;
      if (args == undefined) {
        rowData = this.getRowDataFromToolbar();
      } else {
        rowData = this.getRowData(args);
      }

      let hasRowData = !!rowData;
      if (hasRowData) {
        this.formAction = FormActionEnum.EDIT;
        await this.showForm(rowData);
      }
    },
    deleteTool_click(args) {
      let rowData = null;
      if (args == undefined) {
        rowData = this.getRowDataFromToolbar();
      } else {
        rowData = this.getRowData(args);
      }

      let hasRowData = !!rowData;
      if (hasRowData) {
        //validar que exista
        rowData.isActive = false;
        this.getDeleteConfirmation(rowData);
      }
    },
    async InactivateRow() {
      try {
        var localData = JSON.parse(JSON.stringify(this.deleteDialog.data));

        await this.$store.dispatch("calendars/updateCalendar", {
          id: localData.id,
          calendar: localData
        });
        await this.$store.dispatch("calendars/getCalendars");
        this.$refs.gridCalendar.ej2Instances.dataSource = this.calendarsList;

        this.showToast(
          "Confirmación",
          `Calendario ${localData.description}  Desactivado`,
          2000
        );
      } catch (error) {
        console.log(error);
      }
      this.deleteDialog.data = {};
      this.deleteDialog.hide();
    },
    getDeleteConfirmation(row) {
      this.deleteDialog = DialogUtility.confirm({
        title: "Inactivar Calendario",
        zindex: 1010,
        content: `Confirma que desea inactivar el calendario: ${row.description}`,
        okButton: {
          text: "Inactivar",
          click: this.InactivateRow,
          isPrimary: true
        },

        cancelButton: { text: "Cancelar" },
        showCloseIcon: false,
        closeOnEscape: false,
        animationSettings: { effect: "Zoom" }
      });
      this.deleteDialog.data = row;
      this.deleteDialog.show();
    },
    getAlertDialog(title, content) {
      let dialog = DialogUtility.alert({
        zindex: 1010,
        title: title,
        content: content,
        /* okButton: { text: "OK", click: okClick.bind(this) }, */
        /* cancelButton: {  text: 'Cancel', click: cancelClick.bind(this)},*/
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" }
      });
      return dialog;
    },

    async showDaysForm(data) {
      try {
        if (data !== undefined) {
          await this.$store.dispatch("calendars/getCalendar", data.id);
        }
      } catch (error) {
        console.log(error);
      }
      /* Poner el formulario en modo edición */
      this.dlgDaysShow = true;
    },

    async showForm(data) {
      try {
        if (data !== undefined) {
          if (this.formAction == FormActionEnum.ADD) {
            this.$store.dispatch("calendars/setCalendar", data);
          } else {
            await this.$store.dispatch("calendars/getCalendar", data.id);
          }
        }
      } catch (error) {
        console.log(error);
      }
      /* Poner el formulario en modo edición */
      this.dlgShow = true;
    },
    hideForm() {
      this.dlgShow = false;
      this.dlgDaysShow = false;
      this.$refs.gridCalendar.ej2Instances.dataSource = this.calendarsList;
    },
    getRowDataFromToolbar() {
      var rows = this.$refs.gridCalendar.ej2Instances.getSelectedRows()[0];
      if (!rows) {
        var dlg = this.getAlertDialog(
          "Seleccione Item",
          "No ha seleccionado ningún item"
        );

        dlg.show();
        return null;
      }

      let rowObj = this.$refs.gridCalendar.ej2Instances.getRowObjectFromUID(
        rows.getAttribute("data-uid")
      );

      return rowObj.data;
    },
    getRowData: function(args) {
      /* Consultar los datos si le dan Doble click al grid */
      if (args.type === "actionBegin" && args.requestType === "beginEdit") {
        return args.rowData;
      }

      /* Determinar a que fué que le dieron click, si a la etiqueta o al botón.*/
      var target = args.target;
      /* Si la etiqueta tiene la clase e-edit, es el label y no el botón (Validar si mejor se agrega otra clase) */
      if (target.classList.contains("inline-command")) {
        target = target.parentElement;
      }

      /*Después de tener identificado el Target, entonces buscamos la fila seleccionada */
      let rowObj = this.$refs.gridCalendar.ej2Instances.getRowObjectFromUID(
        target.parentElement.parentElement.parentElement.getAttribute(
          "data-uid"
        )
      );
      //setear los datos.
      return rowObj.data;
    },
    setStyle: function(args) {
      if (args.column.field === "active") {
        var status = args.data["isActive"];
        if (status === true) {
          args.cell.innerText = "Activo";
          args.cell.classList.add("row-active");
          args.cell.classList.remove("row-inactive");
        } else {
          args.cell.innerText = "Inactivo";
          args.cell.classList.remove("row-active");
          args.cell.classList.add("row-inactive");
        }
      }
    }
  }
});
</script>
<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-grids/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-inputs/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-dropdowns/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-popups/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css);
@import url(../../../node_modules/vue-loading-overlay/dist/vue-loading.css);

.e-alert-dialog.e-dialog.e-popup,
.e-confirm-dialog.e-dialog.e-popup {
  margin: auto !important;
}

.e-grid .e-new.e-icons:before,
.e-grid-menu .e-new.e-icons:before {
  content: "\e823";
}

.e-grid .e-view.e-icons:before,
.e-grid-menu .e-view.e-icons:before {
  content: "\e609";
}

.e-icon-dlg-close.e-icons:before,
.e-icon-dlg-close.e-icons:before {
  content: "\ea7f";
}

.e-grid .e-reload.e-icons:before,
.e-grid-menu .e-reload.e-icons:before {
  content: "\e218";
}

.datepicker-panel {
  float: right;
  margin-right: 20px;
}
.datepicker-panel-group {
  display: flex;
}
.content-wrapper {
  width: 100%;
  margin: 15px auto;
  min-width: 185px;
}
@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
}
.e-add-icon {
  background-repeat: no-repeat;
  /* background-image: url('../assets/Plus.png'); */
}

.e-grid .e-rowcell.row-active,
.e-grid .e-rowcell.row-active.e-selectionbackground {
  padding-left: 20px !important;
  color: #0bb60e !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  background-image: url("../../assets/active.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-origin: content-box;
}

.e-grid .e-rowcell.row-inactive,
.e-grid .e-rowcell.row-inactive.e-selectionbackground {
  padding-left: 20px !important;
  color: #f64f4c !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  background-image: url("../../assets/inactive.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-origin: content-box;
}

.e-grid .e-pagerexternalmsg {
  display: none;
}

.e-cal:before {
  content: "\e321";
}
</style>
